export default __webpack_public_path__ + "static/media/kolkata.12e133f0.webp";